import Axios, { InternalAxiosRequestConfig } from "axios";
import { useUserDataStore } from "../stores/user";
import { clearAccessToken, getAccessToken, loginPathForContext } from "./session";

export const axios = Axios.create({
  baseURL: import.meta.env.VITE_AAA_API_URL,
});

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const token = getAccessToken();
  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }
  config.headers.Accept = "application/json";
  return config;
}


axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  error => {
    if (error.response?.status === 401) {
      useUserDataStore.getState().reset();
      clearAccessToken();
      window.location.href = loginPathForContext();
    }
    return Promise.reject(error);
  }
);
